// extracted by mini-css-extract-plugin
export default {"glossaryContainer":"Glossary_glossaryContainer__mnpwY","glossary":"Glossary_glossary__S6yT6","normal":"Glossary_normal__GJjNa","custom":"Glossary_custom__4nd4Q"};